import { gql } from '@apollo/client';

export default gql`
  mutation deleteProc($_id: String) {
    deleteProc(_id: $_id) {
      ok
      message
      error
    }
  }
`;
